import type { ChangelogChangelogReadModelTag } from '@r/api/generated/client.schemas.ts';

/**
 * Classe de badge par catégorie de changelog — teinte douce, sémantique (compatible
 * thème sombre), partagée par toutes les vues (gestion mega admin, feed, historique)
 * pour garder les mêmes couleurs partout.
 */
export const CHANGELOG_TAG_BADGE_CLASS: Record<ChangelogChangelogReadModelTag, string> = {
  feature: 'border-transparent bg-primary/15 text-primary hover:bg-primary/15',
  improvement: 'border-transparent bg-muted text-muted-foreground hover:bg-muted',
  bugfix: 'border-transparent bg-destructive/15 text-destructive hover:bg-destructive/15'
};
